export class DatiCatastaliUrbanoExtra {
  id: string;
  edificio: string;
  piano: string;
  interno: string;
  scala: string;
  categoria: string;
  consistenza: any;
  rendita: any;
  zonaCensuaria: number;
  unitaMisura: string;
}
